import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Price } from '../../component-price';
import { mapResponsiveValue } from '../../component-themes';
import { forwardRef } from 'react';
export const ProductTeaserMiniContentInformationPrice = forwardRef(({ size, ...props }, ref) => (_jsx(Price, { size: mapResponsiveValue(size, (size) => (size === 'sm' ? '2xs' : 'xs')), alignment: "right", orientation: "horizontal", variant: props.energyLabel ? 'wide' : 'narrow', ...props, ref: ref })));
ProductTeaserMiniContentInformationPrice.displayName =
    'ProductTeaserMiniContentInformationPrice';
